'use client'

import dynamic from 'next/dynamic'
import { Suspense } from 'react'

import { ScrollSpyStateProps } from '@/components/Common/ScrollSpy/ScrollSpyStateLogic'

const ScrollSpyStateLogic = dynamic(() => import('@/components/Common/ScrollSpy/ScrollSpyStateLogic'), {
  ssr: true,
})

export default function ScrollSpy({
  id,
  className = '',
  rootMargin = '0px 0px -90% 0px',
  type,
  threshold = 0,
  children,
}: ScrollSpyStateProps) {
  return (
    <Suspense>
      <ScrollSpyStateLogic id={id} className={className} rootMargin={rootMargin} type={type} threshold={threshold}>
        {children}
      </ScrollSpyStateLogic>
    </Suspense>
  )
}
